export default "__VITE_ASSET__CG_ifC_B__"